module.exports = __webpack_public_path__ + "img/Allergologue.73bce007.png";